import { HttpClient } from '@angular/common/http';
import type { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { CbreHttpConfig, CbreHttpConfigToken } from '../cbre-http.config';

@Injectable()
export class HttpMethods {
  protected baseUrl = '/api';
  constructor(private http: HttpClient, @Inject(CbreHttpConfigToken) options?: CbreHttpConfig) {
    if (options) {
      this.baseUrl = options.baseUrl;
    }
  }

  public httpGet(uri: string, params?: HttpParams, options: any = {}): Observable<any> {
    return this.http
      .get(this.baseUrl + uri, { params: params || null, withCredentials: true, ...options })
      .pipe(take(1));
  }

  public httpPost<T>(uri: string, data: T, options?: any): Observable<any> {
    return this.http.post(this.baseUrl + uri, data, { ...options, withCredentials: true }).pipe(take(1));
  }

  public httpDelete<T>(uri: string, options?: T): Observable<any> {
    return this.http.delete(this.baseUrl + uri, { ...options, withCredentials: true }).pipe(take(1));
  }

  public httpPut<T>(uri: string, data?: T, options?: any): Observable<any> {
    return this.http.put(this.baseUrl + uri, data, { ...options, withCredentials: true }).pipe(take(1));
  }
}
